(() => {
  if (window.__cartersBelleTressGallerySwatches) return;
  window.__cartersBelleTressGallerySwatches = true;

  const handleColorSelection = (event) => {
    if (!(event.target instanceof Element)) return;

    const directInput = event.target.closest(
      'variant-picker input[data-belle-tress-color-key]'
    );
    const labelInput = event.target
      .closest('variant-picker label')
      ?.querySelector('input[data-belle-tress-color-key]');
    const input = directInput || labelInput;
    if (!input) return;

    const picker = input.closest('variant-picker');
    const sectionId = picker?.dataset.sectionId;
    const colorKey = input.dataset.belleTressColorKey;
    if (!sectionId || !colorKey) return;

    const selectDesktopGridColor = (section) => {
      const grid = section?.querySelector(
        'media-gallery .media-gallery__grid'
      );
      if (!grid) return;

      grid
        .querySelectorAll(
          '.product-media-container--belle-tress-swatch.belle-tress-gallery-swatch--selected'
        )
        .forEach((item) => {
          item.classList.remove('belle-tress-gallery-swatch--selected');
          item.removeAttribute('aria-current');
        });

      const selectedColor = grid.querySelector(
        `.product-media-container--belle-tress-swatch[data-belle-tress-color-key="${CSS.escape(colorKey)}"]`
      );
      if (!selectedColor) return;

      selectedColor.classList.add('belle-tress-gallery-swatch--selected');
      selectedColor.setAttribute('aria-current', 'true');
    };

    const highlightColorThumbnail = (section) => {
      section
        ?.querySelectorAll('media-gallery .slideshow-controls__thumbnails')
        .forEach((control) => {
          control
            .querySelectorAll('.slideshow-controls__thumbnail')
            .forEach((thumbnail) =>
              thumbnail.setAttribute('aria-selected', 'false')
            );
          control
            .querySelectorAll(
              `.slideshow-controls__thumbnail[data-belle-tress-color-key="${CSS.escape(colorKey)}"]`
            )
            .forEach((thumbnail) => {
              thumbnail.setAttribute('aria-selected', 'true');
              thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            });
        });
    };

    const selectColorSlide = () => {
      const section = document.getElementById(`shopify-section-${sectionId}`);
      selectDesktopGridColor(section);
      const slideshow = section?.querySelector('media-gallery slideshow-component');
      if (!slideshow) return;

      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
      const slide = slides.find((item) =>
        item.querySelector(
          `[data-belle-tress-color-key="${CSS.escape(colorKey)}"]`
        )
      );
      const slideIndex = slide ? slides.indexOf(slide) : -1;

      if (slideIndex >= 0 && typeof slideshow.select === 'function') {
        slideshow.select(slideIndex, undefined, { animate: true });
        highlightColorThumbnail(section);
        return;
      }

      const thumbnail = section.querySelector(
        `media-gallery .slideshow-controls__thumbnail[data-belle-tress-color-key="${CSS.escape(colorKey)}"]`
      );
      thumbnail?.click();
      highlightColorThumbnail(section);
    };

    selectColorSlide();
    window.setTimeout(selectColorSlide, 120);
    window.setTimeout(selectColorSlide, 350);
    window.setTimeout(selectColorSlide, 700);
  };

  document.addEventListener('click', handleColorSelection, true);
  document.addEventListener('change', handleColorSelection, true);

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const thumbnail = event.target.closest(
        'media-gallery .slideshow-controls__thumbnail--belle-tress[data-belle-tress-color-key]'
      );
      if (!thumbnail) return;

      const controls = thumbnail.closest('.slideshow-controls__thumbnails');
      const applyHighlight = () => {
        controls
          ?.querySelectorAll('.slideshow-controls__thumbnail')
          .forEach((item) => item.setAttribute('aria-selected', 'false'));
        thumbnail.setAttribute('aria-selected', 'true');
      };
      applyHighlight();
      window.setTimeout(applyHighlight, 80);
      window.setTimeout(applyHighlight, 250);
    },
    true
  );
})();
